// PARTNER-PORTÁL · Impresszum (statikus, i18n-ből).
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { PortalLegalPage } from '@/components/portal/portal-legal-page';
import { usePortalHead } from '@/features/portal/portal-context';

export const Route = createFileRoute('/portal/legal/imprint')({
  component: PortalImprintPage,
});

function PortalImprintPage(): JSX.Element {
  const { t } = useTranslation();
  usePortalHead({ title: t('portal.nav.imprint'), subtitle: t('portal.legal.imprint.updated') }, [
    t('portal.nav.imprint'),
  ]);
  return <PortalLegalPage blocksKey="portal.legal.imprint.blocks" />;
}
